import { useState } from "react";
import { hexToRgba } from "@/lib/utils";
import TrackRow from "@/components/ui/TrackRow";
import type { ListTrackDto } from "@/lib/lutely-api/gen/dtos/listTrackDto";

type TrackRowWrapperProps = {
  track: ListTrackDto;
  artistColor: string;
  hasBorder: boolean;
};

export function TrackRowWrapper({
  track,
  artistColor,
  hasBorder,
}: TrackRowWrapperProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="px-4 pr-2"
      style={{
        backgroundColor: isHovered ? hexToRgba(artistColor, 0.1) : undefined,
        ...(hasBorder
          ? {
              borderTop: `1px solid ${hexToRgba(artistColor, 0.5)}`,
            }
          : {}),
      }}
    >
      <TrackRow track={track} artistColor={artistColor} disableHoverBg />
    </div>
  );
}
